import React from 'react';
import { withCubicleFallback } from '../../utils/CubicleFallback';

const ListItem = (props) => {
  return <>ListItem</>;
};

const Default = withCubicleFallback(ListItem);
export { Default as ListItem };
